import * as actionTypes from '../action-types';
import { SearchType } from './search.types';
import { SearchActions } from '../actions';

export const defaultState: SearchType = {
  redirectToSearchRoute: true,
  enableWatchers: true,
  enableTypeSelector: true,
  enableAdvice: true,
  enableSnippets: true,
  enableMoreFilters: true,
};

export function searchReducer(
  state: SearchType = defaultState,
  action: SearchActions,
) {
  switch (action.type) {
    // Allow us to deactivate some features for others search
    // can be breaking down in several actions in the future.
    case actionTypes.SWITCH_SEARCH_FEATURES: {
      return {
        redirectToSearchRoute: !state.redirectToSearchRoute,
        enableWatchers: !state.enableWatchers,
        enableTypeSelector: !state.enableTypeSelector,
        enableAdvice: !state.enableAdvice,
        enableSnippets: !state.enableSnippets,
        enableMoreFilters: !state.enableMoreFilters,
      };
    }
    default: {
      return state;
    }
  }
}
